<script>
export default {
  name: 'Managementsection',
  methods: {
    scrollTo($event) {
      const targetQuery = $event.target.getAttribute('href');
      const targetEl = document.querySelector(targetQuery);

      targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.history.pushState(null, null, targetQuery);
    },
  },
}
</script>

<template>
  <div
    id="management"
    class="row"
  >
    <div class="container">
      <section class="section">
        <div class="wrap-info">
          <h2 class="huge-title">
            Gestão de campanhas
          </h2>

          <p>
            Além de ser uma plataforma que atua com as melhores tecnologias para segurança e suportar o maior número de acessos simultâneos, oferecemos uma plataforma autônoma para acompanhamento em tempo real das doações, automatização na emissão de recibos eleitorais e importação dos dados de maneira prática com o sistema de prestação de contas do TSE (SPCE).
          </p>
          <p>
            Nos preocupamos muito com os doadores, oferecendo informações detalhadas sobre quais são suas obrigações e responsabilidades com relação ao processo de doação, assim como seus limites e os auxiliando na declaração de imposto de renda.
          </p>
          <a
            class="call-to-action-button"
            href="#email"
            @click.prevent="scrollTo"
          >
            estou interessado
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
	span {
		color: #4bb958;
	}

  .call-to-action-button {
    margin-top: 1rem;
    display: inline-block;
    padding: 0.6rem 2rem;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 600;
    border: 2px solid #fff;
    border-radius: 8px;
    background-color: transparent;
  }

	#management {
		color: white;
		background-color: #203f57;
		padding-top: 12.5rem;
		background-image: url('../../img/bg-gestao--320w.jpg');
		background-size: cover;
		box-sizing: border-box;

		@media screen and (min-width: 480px){
			background-image: url('../../img/bg-gestao--480w.jpg');
		}

		@media screen and (min-width: 640px){
			background-image: url('../../img/bg-gestao--640w.jpg');
		}

		@media screen and (min-width: 960px){
			background-image: url('../../img/bg-gestao--960w.jpg');
		}

		@media screen and (min-width: 1280px){
			background-image: url('../../img/bg-gestao--1280w.jpg');
		}

		@media screen and (min-width: 1920px){
			background-image: url('../../img/bg-gestao--1920w.jpg');
		}

		p {
			margin-bottom: 1em;
			max-width: 33em;
		}

		.call-to-action{
      font-size: 18px;
			font-weight: bold;
			font-style: normal;
			color: #fff;
			text-transform: lowercase;
			text-decoration: underline;


      cursor: pointer;
      position: relative;

			&:hover{
				color: rgb(51, 204, 102);
			}
		}

		.wrap-info {
			box-sizing: border-box;
			background-color: rgb(32, 64, 87);
			background-repeat: no-repeat;
			background-image: url('../../img/img-gestao.jpg');
			background-position: right top;
			background-size: 522px 465px;
			min-height: 465px;
				padding-top: 10rem;
				padding-bottom: 5rem;
				padding-left: 1rem;
				padding-right: 1rem;

			@media (min-width: 380px) {
				padding-top: 3rem;
				padding-bottom: 3rem;
				padding-left: 2rem;
				padding-right: 2rem;
			}

			@media (min-width: 500px) {
				padding-top: 4rem;
				padding-bottom: 4rem;
				padding-left: 3rem;
				padding-right: 3rem;
			}

			@media (min-width: 1200px) {
				padding-top: 5rem;
				padding-bottom: 5rem;
				padding-left: 4rem;
				padding-right: 4rem;
			}


			position: relative;

			@media only screen and (min-resolution: 192dpi) {
				background-image: url('../../img/img-gestao@2x.jpg');
			}

			@media only screen and (min-resolution: 2dppx) {
				background-image: url('../../img/img-gestao@2x.jpg');
			}

			@media only screen and (min-resolution: 288dpi) {
				background-image: url('../../img/img-gestao@3x.jpg');
			}

			@media only screen and (min-resolution: 3dppx) {
				background-image: url('../../img/img-gestao@3x.jpg');
			}

			&::before {
				position: absolute;
				background-image: url('../../img/img-gestao-top.png');
				background-size: 436px 152px;
				width: 436px;
				height: 152px;
				content: '';
				top: -152px;
				right: 0;

				@media only screen and (min-resolution: 192dpi) {
					background-image: url('../../img/img-gestao-top@2x.png');
				}

				@media only screen and (min-resolution: 2dppx) {
					background-image: url('../../img/img-gestao-top@2x.png');
				}

				@media only screen and (min-resolution: 288dpi) {
					background-image: url('../../img/img-gestao-top@3x.png');
				}

				@media only screen and (min-resolution: 3dppx) {
					background-image: url('../../img/img-gestao-top@3x.png');
				}

			}

			h2 {
				position: absolute;
				right: 0;

				bottom: 100%;
				z-index: 1;
				max-width: 100%;
			}

			p + p {
				padding-bottom: 3.75rem;
				margin: 0;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/managementsection.vue